export const handleStopPropagation = (_, e) => {
  if (e) {
    e.stopPropagation();
  }
};

export default handleStopPropagation;
